/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsCreateRun } from "../../funcs/llmEvalsCreateRun.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateEvalRunRequest$inboundSchema,
};

export const tool$llmEvalsCreateRun: ToolDefinition<typeof args> = {
  name: "llm-evals-create-run",
  description: `Create an eval run

Starts a durable eval run over the selected suite version, tasks, and models.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsCreateRun(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
